<template>
  <div>
    <h1 class="title">Editar precio de venta de productos</h1>
    <div class="notification">
      <strong>Edita el predio de venta</strong> Con el siguiente botón podra
      editar el precio de venta de todos los productos para que queden con
      valores antes de iva. <br />
      Esto sucede si el cliente por error monto todos los precios con el valor
      despues de iva. <br /><br />
      <button class="button is-link" @click="editprecioproducto">
        Editar precios de venta
      </button>
      <!-- <button class="button is-link" @click="eliminapaisesdupl">
        eliminar paises duplicados
      </button> -->
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
export default {
  methods: {
    async editprecioproducto() {
      try {
        const result = await apiServices.get(`/editprecioproductolote`);
        if (result.data) {
          console.log(result.data);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async eliminapaisesdupl() {
      try {
        const result = await apiServices.get(`/eliminapaisesdupl`);
        if (result.data) {
          console.log(result.data);
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/editproducto/Editproducto.vue